var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgJobDelivery = function SvgImgJobDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 36V11h42v25",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 40.5V34l25 14 25-14v30h-50v-6",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.667 64 21-18M50.667 46l21 18M21.667 34l4-4M67.667 30l4 4",
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.297 34.26a7.63 7.63 0 1 0 0-15.26 7.63 7.63 0 0 0 0 15.26Z",
    fill: "#326DE6",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.507 32.57a7.572 7.572 0 0 0 4.79 1.69c1.82 0 3.48-.64 4.79-1.69a7.572 7.572 0 0 0-4.79-1.69c-1.82 0-3.48.64-4.79 1.69ZM39.297 28.67a3.05 3.05 0 1 0 0-6.1 3.05 3.05 0 0 0 0 6.1Z",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.036 22.57h10.17M51.036 26.63h10.17M51.036 30.7h5.09",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 44h-17M26.667 55h-17M32.667 49h-17",
    stroke: "#000",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
export default SvgImgJobDelivery;